/* istanbul ignore file */
export const organismeMapper = (listOrganismes: any[]) =>
  listOrganismes?.map((org) => {
    return {
      name: org?.id,
      label: org?.NOM_SOUSCRIPTEUR,
      numPolice: org?.NUM_POLICE,
    };
  });

export const categoriesMapper = (listCategoriesParam: any[]) =>
  listCategoriesParam.map((cat) => {
    return {
      name: cat.Id,
      label: cat.Libelle,
    };
  });

export const filesMapper = (listFiles: any[]) =>
  listFiles.map((file) => {
    return {
      icon: 'cardIcon',
      title: file.LibellePiece,
    };
  });
